// «🎆 Una bella notizia»: la carta in cima alla Casa, con i fuochi d'artificio.
//
// Titolo e testo vengono dal server e sono DATI: finiscono in nodi di testo (mai in HTML), perché il
// codice è lo stesso per mamma e per Simonetta e nessun testo personale vive qui.
//
// I fuochi sono solo decorazione: stanno in un contenitore `aria-hidden` e li anima ornamenti.css
// (solo transform/opacity, solo con ornamenti pieni, movimento non ridotto, mai mentre registra).
// Senza quelle condizioni il contenitore resta vuoto e invisibile e la carta è testo semplice, per
// intero. Niente suoni, niente camera, niente aperture automatiche: la carta aspetta il suo tocco.
import { api } from './api.js';
import { el } from './ui.js';

export type NotiziaDaVedere = { id: number; titolo: string; testo: string };

/** Quattro scoppi fissi (sempre uguali, come le foglie dell'albero): posizione in %, ritardo in s. */
const SCOPPI: Array<[number, number, number]> = [[16, 34, 0], [82, 26, 0.7], [48, 62, 1.4], [70, 78, 2.1]];
const SCINTILLE = 12;

function fuochi(): HTMLElement {
  return el('div', { class: 'notizia-fuochi', 'aria-hidden': 'true' },
    ...SCOPPI.map(([x, y, ritardo], n) => el('span', { class: 'fuoco', style: `--x:${x}%;--y:${y}%;--r:${ritardo}s;--c:${n}` },
      ...Array.from({ length: SCINTILLE }, (_, i) => {
        const angolo = (i / SCINTILLE) * 2 * Math.PI;
        const raggio = i % 2 === 0 ? 92 : 58;
        return el('i', { style: `--dx:${Math.round(Math.cos(angolo) * raggio)}px;--dy:${Math.round(Math.sin(angolo) * raggio)}px` });
      }))));
}

/** La carta. `finita` si chiama dopo il «visto» registrato dal server (la Casa si ridisegna). */
export function cartaNotizia(n: NotiziaDaVedere, finita: () => void): HTMLElement {
  const titoloId = `notizia-titolo-${n.id}`;
  const bottone = el('button', {
    class: 'btn-primario', type: 'button', 'data-ruolo': 'notizia-ok',
    click: async () => {
      await api.post(`/api/notizie/${n.id}/vista`);
      finita();
    },
  }, 'Che bello! 💚');
  return el('section', { class: 'carta carta-annuncio carta-notizia', 'data-ruolo': 'notizia', 'aria-labelledby': titoloId },
    fuochi(),
    el('p', { class: 'etichetta' }, '🎆 Una bella notizia'),
    el('h2', { class: 'notizia-titolo', id: titoloId }, n.titolo),
    el('p', { class: 'domanda-testo notizia-testo' }, n.testo),
    bottone,
  );
}
